<div class="signature-container">
    <!-- Signature Mode Selector -->
    <!-- <div class="signature-mode-selector">
        <div class="mode-tabs">
            <button 
                type="button" 
                [class.active]="!showAutoComplete" 
                (click)="toggleAutoComplete(false)">
                Draw
            </button>
            <button 
                type="button" 
                [class.active]="showAutoComplete" 
                (click)="toggleAutoComplete(true)">
                Type
            </button>
        </div>
    </div> -->

    <!-- Auto-generated Signature UI -->

    <!-- Manual Signature Pad -->
    <div class="signature-pad-container" [style.width.px]="options.width">
        <canvas
            #signatureCanvas
            (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()"
            [width]="options.width"
            [height]="options.height"
            (mousedown)="onMouseDown($event)"
            (mousemove)="onMouseMove($event)"
            (mouseup)="onMouseUp()"
            (mouseleave)="onMouseLeave()"
            (touchstart)="onTouchStart($event)"
            (touchmove)="onTouchMove($event)"
            (touchend)="onTouchEnd()"
            class="signature-pad-canvas">
        </canvas>

        <div *ngIf="showCursorIndicator" class="cursor-indicator" 
        [style.left.px]="cursorPosition.x" 
        [style.top.px]="cursorPosition.y">
   </div>

        <button
                type="button"
                class="clear-button"
                [class.disabled]="isEmpty"
                [disabled]="isEmpty"
                (click)="clearSignature($event)">
            <i class="bi bi-eraser"></i>&nbsp;Clear
        </button>
    </div>

    <div class="auto-signature-ui">
        <div class="auto-signature-form">
            <div class="name-input-group">
                <label for="nameInput">Your name</label>
                <input 
                    type="text" 
                    id="nameInput" 
                    [value]="nameInput"
                    (input)="onNameInputChange($event)" 
                    placeholder="Type your full name">
            </div>
        </div>
    </div>
</div>